import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { PageLayoutProps } from './PageLayoutTypes.ts';

export const PageLayout: LoadableType<PageLayoutProps> = LoadablePaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-Nav4-layout" */ './PageLayout.tsx')).PageLayout,
});
